let delay = 1;

function setBlocks() {
    const blocks = Array.from(document.getElementsByClassName('industry'));

    blocks.forEach((k) => {
        k.style.transition = 'all 0.2s ease';
        k.style['transition-delay'] = `${delay}s`;
        delay += 0.125;
        k.classList.add('waypoint--bottom');
    });

    blocks.forEach((k) => {
        k.classList.remove('waypoint--bottom');
    });
}

function init() {
    setBlocks();
}

export default init;
